import { Link } from 'react-router-dom';
import { useLayoutContext } from '../context/useLayoutContext';

/** Filenames match layout theme: `dark` → logo-dark*, `light` → logo-light* */
const ASSETS = {
  fullDark: '/logo-dark-full.png',
  iconDark: '/logo-dark.png',
  fullLight: '/logo-light-full.png',
  iconLight: '/logo-light.png',
};

/** Login always uses this asset (square mark), regardless of app theme. */
const LOGIN_LOGO_SRC = '/logo-light.png';

const LogoBox = ({ containerClassName, squareLogo, textLogo }) => {
  const { theme } = useLayoutContext();
  const isDark = theme === 'dark';

  const fullSrc = isDark ? ASSETS.fullDark : ASSETS.fullLight;
  const iconSrc = isDark ? ASSETS.iconDark : ASSETS.iconLight;

  const isAuthPage = containerClassName?.includes('auth-logo');
  const isSidebar = containerClassName?.includes('logo-box');

  const fullClassName = ['logo-img', 'logo-img--full', textLogo?.className].filter(Boolean).join(' ');
  const iconClassName = ['logo-img', 'logo-img--icon', squareLogo?.className].filter(Boolean).join(' ');
  const loginClassName = ['logo-img', 'logo-img--login', textLogo?.className].filter(Boolean).join(' ');

  if (isAuthPage) {
    return (
      <div className={containerClassName ?? ''}>
        <span className="d-inline-flex align-items-center justify-content-center text-body">
          <span className="logo-badge">
            <img src={LOGIN_LOGO_SRC} alt="Sanduk" className={loginClassName} />
          </span>
        </span>
      </div>
    );
  }

  if (isSidebar) {
    return (
      <div className={containerClassName ?? ''}>
        <Link
          to="/dashboard"
          className="logo-link d-inline-flex align-items-center justify-content-center text-decoration-none text-body"
        >
          <span className="logo-expanded logo-badge">
            <img src={fullSrc} alt="Sanduk" className={fullClassName} />
          </span>
          <span className="logo-condensed logo-badge">
            <img src={iconSrc} alt="Sanduk" className={iconClassName} />
          </span>
        </Link>
      </div>
    );
  }

  return (
    <div className={containerClassName ?? ''}>
      <Link to="/dashboard" className="logo-link d-inline-flex align-items-center text-decoration-none text-body">
        <span className="logo-badge">
          <img src={fullSrc} alt="Sanduk" className={fullClassName} />
        </span>
      </Link>
    </div>
  );
};

export default LogoBox;
